import React from "react";
import { Heading, VStack } from "@chakra-ui/react";
import SkillsBox from "./SkillsBox";
import SkillsCard from "./SkillsCard";




const Design = () => {
    return (
        <div id="design">
            <Heading size={"md"} className="my-6">
                Design Skills.
            </Heading>
            <VStack>
                <SkillsBox>
                    <SkillsCard
                        title={"Figma"}
                        text={
                            "Figma is a powerful design tool that helps you to create anything: websites, applications, logos, and much more."
                        }
                        cat={"Web"}
                        photo={'https://i.ibb.co/LkMbzsh/figma-logo-E4-E21-D3-AEA-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"InDesign"}
                        text={
                            "Adobe InDesign is the industry-leading layout and page design software for print and digital media."
                        }
                        cat={"UI Design"}
                        photo={''}
                    />

                    <SkillsCard
                        title={"Illustrator"}
                        text={
                            "Adobe Illustrator is the industry standard design app that lets you capture your creative vision with shapes, color, effects, and typography"
                        }
                        cat={"Vector "}
                        photo={''}
                    />
                    <SkillsCard
                        title={"Photoshop"}
                        text={
                            "Adobe Photoshop is an imaging and graphic design software used by thousands of people in many different roles across the world."
                        }
                        cat={"Image"}
                        photo={'https://i.ibb.co/PxVx8vS/adobe-photoshop-logo-7-B88-D7-B5-AA-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Premier Pro"}
                        text={
                            "Premiere Pro is used for editing videos, commercials and other film, television, and online video."
                        }
                        cat={"Video"}
                        photo={'https://i.ibb.co/XxrkrDB/adobe-premiere-logo-0-B31-ECF881-seeklogo-com.png'}
                    />
                </SkillsBox>
                <SkillsCard
                        title={"After Effect"}
                        text={
                            "After Effect is used for animation videos, commercials and other film, television, and online video."
                        }
                        cat={"Video"}
                        photo={'https://i.ibb.co/yVqqX1p/adobe-after-effects-logo-960-B473-FE4-seeklogo-com.png'}
                    />
                
            </VStack>
        </div>
    );
};

export default Design;
